<label for="{{componentId}}" class="btn btn-block for-icon-right text-left borderStyle {{displayIconClass}} {{cssOverrideClass}}">
  {{displayText}}
</label>
<input type="file" id="{{componentId}}" class="uploadBtnStyle_1" [attr.multiple]="allowMultipleFiles ? true : null" (change)="onFileChange($event)" />
